import React, { useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate } from 'react-router-dom'
import { SuccessfullyModal } from '../../components/Modals/Modals'
import { getApi, postApi } from '../../Repository/Api'
import endPoints from '../../Repository/apiConfig'


const AddNewFAQ = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const [question, setQuiestion] = useState('');
    const [answer, setAnswer] = useState('');
    const [categoryid, setCategoryId] = useState('');
    const [status, setStatus] = useState('');
    const [categoryname, setCategoryName] = useState('');
    const [category, setCategory] = useState([]);



    const handleSubmit = async () => {
        const payload = {
            question: question,
            answer: answer,
            status: status,
            category: categoryid,
        };

        await postApi(endPoints.addfaq, payload, {
            setLoading,
            successMsg: 'FAQ added successfully!',
            errorMsg: 'Failed to add FAQ!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
            navigate('/FAQ'); // Redirect to the Privacy Policy list page
        }, 2000);
    };


    const fetchData = async () => {
        await getApi(endPoints.getallcategory, {
            setResponse: setCategory,
            setLoading: setLoading,
            errorMsg: "Failed to fetch Category!",
        });
    };

    useEffect(() => {
        fetchData();
    }, []);


    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Added"}
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Add New FAQ</h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
                            <p>View FAQ</p>
                        </div>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>FAQ  Details</h6>
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">QuestionTitle*</label>
                            <input
                                type="text"
                                placeholder='Enter the Question'
                                value={question}
                                onChange={(e) => setQuiestion(e.target.value)}
                            />
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">Answer*</label>
                            <input
                                type="text"
                                placeholder='Enter the Answer'
                                value={answer}
                                onChange={(e) => setAnswer(e.target.value)}
                            />
                        </div>
                        <div className={addjob.addvouchercontainer}>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Choose Category*</label>
                                <select
                                    value={categoryid || ""}
                                    onChange={(e) => {
                                        const selectedCategory = category?.data?.find(
                                            (category) => category._id === e.target.value
                                        );
                                        setCategoryId(e.target.value);
                                        setCategoryName(selectedCategory?.name || "");
                                    }}
                                >
                                    <option value="">Select Category</option>
                                    {category?.data?.map((category) => (
                                        <option key={category._id} value={category._id}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Choose Status*</label>
                                <select
                                    onChange={(e) => setStatus(e.target.value)}
                                    value={status}
                                >
                                    <option value="">Select</option>
                                    <option value="Published">Published</option>
                                    <option value="Un Published">Un Published</option>
                                    <option value="Drafts">Drafts</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className={addjob.addjobbutton}>
                        <div className={addjob.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                        <div className={addjob.rightbuttons}>
                            <button
                                onClick={handleSubmit}
                                style={{ background: '#F05423' }}
                                disabled={loading}
                            >
                                {loading ? "Adding..." : "Add"}
                            </button>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default HOC(AddNewFAQ)